module.exports = __webpack_public_path__ + "img/84_6.be11e55a.png";